export const QUICK_COMMENT_TEMPLATE_KEYS = [
  'order_details_quick_comment_client_called',
  'order_details_quick_comment_client_unreachable',
  'order_details_quick_comment_in_stock_supplier',
  'order_details_quick_comment_out_of_stock_supplier',
  'order_details_quick_comment_in_stock_tv',
  'order_details_quick_comment_checking_availability',
] as const;

export type QuickCommentTemplateKey = (typeof QUICK_COMMENT_TEMPLATE_KEYS)[number];
